// Shared styles for Button components
export const createButtonStyles = (theme) => ({
  // Common base styles
  baseCommon: {
    boxSizing: 'border-box',
    borderRadius: 12,
    textTransform: 'none',
    transition: 'all 0.4s',
    '&:disabled': {
      opacity: 0.7,
    },
  },

  // Color variants - shared between Button and IconButton
  main: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    border: '2px solid transparent',
    backgroundImage: `linear-gradient(${theme.palette.primary.main}, ${theme.palette.primary.main}), linear-gradient(0deg, rgba(0,0,0,0.20) 0%, rgba(255,255,255,0.20) 100%)`,
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },

  alternative: {
    backgroundColor: theme.palette.buttons.alternative.background,
    color: theme.palette.buttons.alternative.text,
    border: `1px solid ${theme.palette.buttons.alternative.hover}`,
    '&:hover': {
      backgroundColor: theme.palette.buttons.alternative.hover,
    },
  },

  white: {
    backgroundColor: 'white',
    border: '2px solid transparent',
    backgroundImage: `linear-gradient(white, white), linear-gradient(0deg, rgba(0,0,0,0.20) 0%, rgba(255,255,255,0.20) 100%)`,
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    color: 'black',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
  },

  noColor: {
    backgroundColor: 'transparent',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },

  black: {
    backgroundColor: '#26272B',
    color: 'white',
    '&:hover': {
      backgroundColor: '#26272B90',
    },
  },

  outline: {
    backgroundColor: 'transparent',
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.border.default}`,
    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04)',
    },
  },
});

// Button-specific styles
export const createTextButtonStyles = (theme) => {
  const commonStyles = createButtonStyles(theme);

  return {
    ...commonStyles,
    base: {
      ...commonStyles.baseCommon,
      minWidth: 120,
      height: 36,
      fontSize: 17,
      padding: 10,
    },
    small: {
      minWidth: 80,
      height: 36,
      padding: 8,
    },
    medium: {
      minWidth: 100,
      height: 40,
      padding: 12,
    },
    large: {
      minWidth: 120,
      height: 48,
      padding: 12,
    },
    mainText: {
      backgroundImage: theme.palette.primary.main,
    },
    title: {
      fontSize: 17,
      backgroundColor: 'transparent',
    },
    movingText: {
      opacity: 1,
      overflow: 'hidden',
      '&:hover': {
        '& img': {
          transform: 'translateX(340%)',
          transition: 'all 0.6s',
        },
        '& h1': {
          transform: 'translateX(200%)',
          transition: 'all 0.6s',
        },
      },
    },
    icon: {
      height: 30,
      left: '-35%',
      position: 'absolute',
      transition: 'all 0.6s',
    },
    fullWidth: {
      width: '100%',
    },
  };
};

// IconButton-specific styles
export const createIconButtonStyles = (theme) => {
  const commonStyles = createButtonStyles(theme);

  return {
    ...commonStyles,
    base: {
      ...commonStyles.baseCommon,
      width: 40,
      height: 40,
      padding: 8,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    small: {
      width: 36,
      height: 36,
      padding: 6,
    },
    large: {
      width: 56,
      height: 56,
      padding: 12,
    },
  };
};
